import {Modal, ModalContent, ModalTitle} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {KilnShutdownForm} from '@refra/modules/common/components/KilnShutdownForm'
import {useRefraModal, useShutdowns} from '@refra/modules/common/providers'

export const NewShutdownModal = () => {
  const {t} = useTranslation()
  const {currentShutdowns} = useShutdowns()
  const {closeModal} = useRefraModal()

  const shutdown = currentShutdowns.find((shutdown) => shutdown.id === undefined)

  if (!shutdown) {
    closeModal()
    return null
  }

  return (
    <Modal open onClose={() => console.log('close')} data-cy="refra_add_material_modal">
      <ModalTitle data-cy="add_shutdown_modal_title">
        {t('refraPlanning.kilnShutdown.newShutdown')}
      </ModalTitle>
      <ModalContent>
        <KilnShutdownForm kilnShutdown={shutdown} isRowLayout={false} />
      </ModalContent>
    </Modal>
  )
}
